const amountOfTaskCategoryFeaturedBlocksOnPage = 20;

export default amountOfTaskCategoryFeaturedBlocksOnPage;
